import React, { useState } from 'react'
import { ConfirmationModal } from 'src/components'

interface UseConfirmDeleteModalProps {
  confirmDelete: () => Promise<void>
  isDeleting: boolean
}

export const useConfirmDeleteModal = ({ confirmDelete, isDeleting }: UseConfirmDeleteModalProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  const onConfirm = async () => {
    await confirmDelete()
    close()
  }

  const ConfirmationModalComponent = () => (
    <ConfirmationModal
      isOpen={isOpen}
      title='Confirmar Exclusão'
      message='Tem certeza que deseja excluir este pasto?'
      onConfirm={onConfirm}
      onCancel={close}
      isLoading={isDeleting}
      confirmText='Confirmar'
      cancelText='Cancelar'
    />
  )

  return {
    open,
    close,
    isOpen,
    ConfirmationDeleteModal: ConfirmationModalComponent
  }
}
